import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const usePageTitle = (customTitle?: string) => {
  const { t } = useTranslation(["common"]);
  const { pathname } = useLocation();

  const getPageTitle = (pageSlug: string) => {
    if (pageSlug === "ulohy") return t("pageNameEnvelopesAndTasks");
    if (pageSlug === "kalendar") return t("pageNameCalendar");
    if (pageSlug === "ulozene") return t("pageNameBookmarks");
    if (pageSlug === "vyrazene") return t("pageNameBlacklist");
    if (pageSlug === "historie") return t("pageNameHistory");
    if (pageSlug === "matematika") return t("pageNameMath");
    if (pageSlug === "cesky-jazyk") return t("pageNameCzech");
    if (pageSlug === "anglictina") return t("pageNameEnglish");
    if (pageSlug === "statistiky") return t("pageNameMyAchievements");
    if (pageSlug === "nastaveni") return t("pageNameSettings");
    if (pageSlug === "dotazy") return t("pageNameHelp");
    if (pageSlug === "reklamovane-odpovedi") return t("pageNameUnrecognizedAnswers");
    if (pageSlug === "vsechny") return t("pageNameBooksAll");
    if (pageSlug === "muj-vyber") return t("pageNameBooksMySelection");
    if (pageSlug === "neumelecke-texty") return t("pageNameBooksNonArtistic");
    if (pageSlug === "masterclass") return t("pageNameMasterclass");
    if (pageSlug === "dev") return "Dev";
    if (pageSlug === "zmena-telefonu") return t("phoneValidation.heading", { ns: "settings" });
    if (pageSlug === "overeni-telefonu") return t("phoneValidation.heading", { ns: "settings" });
    if (pageSlug === "zvuk") return t("pageNameBackgroundSound");
    if (pageSlug === "zelena") return t("pageNameGreenEnvelope");
    if (pageSlug === "oranzova") return t("pageNameOrangeEnvelope");
    if (pageSlug === "cervena") return t("pageNameRedEnvelope");
  };

  const [titleParts, setTitleParts] = useState<string[]>([]);

  useEffect(() => {
    if (customTitle) {
      setTitleParts([customTitle]);
      return;
    }

    const slug = pathname.split("/").at(-1);

    if (slug) {
      const title = getPageTitle(slug);
      if (title) {
        setTitleParts([title]);
        return;
      }
    }

    setTitleParts([]);
  }, [pathname]);

  return { titleParts };
};
